import { handleErrorResponse } from "../services/functions";

// utils/authGuard.js
export const assertAuth = (authData,dispatch,redirectPath = undefined) => {
  if (!authData || !authData?.isLoggedIn) {
    if (redirectPath) {
      localStorage.setItem("redirect", redirectPath);
    }
    handleErrorResponse({ response: { data: { message: "Please login!!" }, status: 401 } }, dispatch);
    return false;
  }
  return true;
};

export const getRoleLabel = (authData) => {
  if (authData?.role === 'producer') {
    const active = authData?.subscribed;
    return {
      text: active ? "Professional · Active" : "Professional · Inactive",
      status: active ? 'success' : 'error',
    };
  }
  if (authData?.role === 'consumer') {
    return { text: "Member · Active", status: 'success' };
  }
  return null;
};